import { More } from "@/shared/actions/more";
import { FormInModal } from "@/shared/form/form-in-modal";
import { useTranslations } from "use-intl";
import { useEntityAttributeById } from "../model/entity-attributes/use-entity-attribute-by-id";

import { EditSimpleAttribute } from "./edit-simple-attribute";
import { EditEnumAttribute } from "./edit-enum-attribute";

export type EditAttributeFormInModalProps = {
  attributeId: string;
};

export function EditAttributeFormInModal({
  attributeId,
}: EditAttributeFormInModalProps) {
  const t = useTranslations("EntityAttributeList");

  const attribute = useEntityAttributeById(attributeId);

  if (!attribute) {
    return null;
  }

  return (
    <FormInModal
      title={t("Edit attribute")}
      trigger={(open) => <More.Edit onClick={open} />}
      form={(close) => (
        <>
          {attribute.__typename === "SimpleTypeDynamicAttributeDto" && (
            <EditSimpleAttribute
              attributeId={attributeId}
              afterSubmit={close}
            />
          )}

          {attribute.__typename === "EnumTypeDynamicAttributeDto" && (
            <EditEnumAttribute afterSubmit={close} attributeId={attributeId} />
          )}
        </>
      )}
    />
  );
}
